import { Runtime } from '@/core/enums/runtime.enum'

export const RUNTIME_MAP: Record<Runtime, string> = {
  [Runtime.Nodejs]: 'nodejs',
  [Runtime.Jvm]: 'jvm',
  [Runtime.Netcore]: 'netcore',
  [Runtime.Python]: 'python',
  [Runtime.Ruby]: 'ruby',
  [Runtime.Php]: 'php',
} as const
